import { getField } from 'vuex-map-fields'
import buildInitialStatus from '@/store/helpers/buildInitialState'

const defaultMessage = 'Processing. Please wait...'

const progressModal = {
  namespaced: true,
  state: buildInitialStatus({
    showModal: false,
    message: defaultMessage
  }),
  getters: {
    getField
  },
  actions: {
    showProgressModal: ({ commit }, { message = defaultMessage }) => {
      return commit('showProgressModal', { message })
    },
    hideProgressModal: ({ commit }) => {
      commit('hideProgressModal')
    }
  },
  mutations: {
    showProgressModal (state, { message }) {
      state.showModal = true
      state.message = message
    },
    hideProgressModal (state) {
      state.showModal = false
      state.message = defaultMessage
    }
  }
}

export default progressModal
